import { useState } from 'react';
import p_nav_previous from '../Assets/Images/p_navbars.svg';
import { getMyProfileDetails, notificationCounts } from '../Services/api';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import p_nav_book_outline from "../Assets/Images/p_nav_book_outline.svg";
import p_nav_message_outline from "../Assets/Images/p_nav_message_outline.svg";
import p_nav_notifications_outline from "../Assets/Images/p_nav_notifications_outline.svg";
import p_nav_about_outline from "../Assets/Images/p_nav_about_outline.svg";
import p_nav_setting_outline from "../Assets/Images/p_nav_setting_outline.svg";
import p_nav_location from "../Assets/Images/p_nav_location.png";
import p_nav_next_outline from "../Assets/Images/p_nav_next_outline.svg";
import { useDispatch, useSelector } from 'react-redux';
import GuestUserSideBar from '../Components/SideBar/guestUser_sideBar';
import { clearUserToken } from '../redux/slices/userTokenSlice';


const UserSettings = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch()
    const state = useSelector((state) => state);
    const [userData, serUserData] = useState(state?.userAuth?.user);
    function logOut() {
        dispatch(clearUserToken());

        navigate("/login", { replace: true });
    }

    const [modalOpen, setModalOpen] = useState(false);

    const openModal = () => {
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };
    function removeExtraFadeFromOffcanvas() {
        const myOffcanvas = document.getElementById('offcanvasTop');
        myOffcanvas.addEventListener('shown.bs.offcanvas', event => {
            let fade = document.getElementsByClassName('offcanvas-backdrop fade show')
            for (let i = 0; i < fade.length; i++) {
                while (fade.length > 1) {
                    fade[i].remove()
                }
            }
        });
    }
    const [notificationcount, setNotificationcount] = useState("");
    const [profile, setProfileData] = useState("");
    const [showSidebar, setShowSidebar] = useState(false);

    const toggleSidebar = () => {
        setShowSidebar(!showSidebar)
    }

    useEffect(() => {
        if (userData.user_type != "Guest") {
            getMyProfileDetails().then((res) => {
                setProfileData(res.data?.user_details);
            });
            notificationCounts().then((res) => {

                setNotificationcount(res.data);
            });
        }
        // else {
        //     navigate('/login');
        // }
    }, [])

    return (
        <>
            <div className="d-flex justify-content-between align-items-center p-3 p-navbar bg-white  offcanvas-parentType1">
                <div className="d-flex justify-content-between align-items-center  ">
                    {
                        userData?.user_type == "Guest" ?
                            <img src={p_nav_previous} width={'24px'} height={'16px'} alt='Previous Button' role='button' onClick={() => toggleSidebar()} /> :

                            <img src={p_nav_previous} width={'24px'} height={'16px'} alt='Previous Button' role='button' data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasTop" aria-controls="offcanvasTop" onClick={removeExtraFadeFromOffcanvas} />
                    }

                    {/* <img src={p_nav_previous} width={'24px'} height={'16px'} alt='Previous Button' role='button' data-bs-toggle= "offcanvas"
                        data-bs-target="#offcanvasTop" aria-controls="offcanvasTop" onClick={removeExtraFadeFromOffcanvas} /> */}

                    <div className='ff-balooPaaji2-bold fs-20 ms-2 ps-1'>Settings</div>
                </div>

                <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasTop" aria-labelledby="offcanvasTopLabel" >
                    <div className="offcanvas-body p-0">
                        <Link to={`/dashboard`} className="text-decoration-none">
                            <div className="profileDetails primary-bg p-3 text-white d-flex justify-content-between align-items-center">
                                <div className="d-flex">
                                    <img src={profile?.user_img} width={"84px"} height={"81px"} className='profile' alt='img' />
                                    <div className="ms-2">
                                        <div className="ff-poppins-semiBold fs-16">
                                            {profile?.user_name}
                                        </div>
                                        <div className="ff-balooPaaji2-regular fs-12">
                                            UID:{profile?.user_id}
                                        </div>
                                        {profile?.user_city &&
                                            <div className="ff-balooPaaji2-regular fs-12">
                                                <img src={p_nav_location} width={"12px"} height={"12px"} className="me-1" alt='img' />
                                                {profile?.user_city}
                                            </div>
                                        }
                                    </div>
                                </div>
                                <img src={p_nav_next_outline} width={"24px"} height={"24px"} alt='img' />
                            </div>
                        </Link>

                        <div>
                            <div className="d-flex p-3" role="button" onClick={() => navigate('/')} >

                                <img src={p_nav_book_outline} width={"24px"} height={"24px"} alt='img' />
                                <div className="ff-poppins-regular fs-16 ms-3">
                                    Bookings Manager
                                </div>
                            </div>

                            <Link
                                to={`/messenger-list`}
                                className="text-decoration-none text-dark"
                            >
                                <div className="d-flex p-3" role="button">
                                    <img src={p_nav_message_outline} width={"24px"} height={"24px"} alt='img' />
                                    <div className="d-flex justify-content-between w-100">
                                        <div className="ff-poppins-regular fs-16 ms-3">Messenger</div>
                                        <p className="p-0 m-0">
                                            {notificationcount.unread_message_count > 0 ?
                                                <span className="notification_count">
                                                    {notificationcount.unread_message_count >= 9 ? "9+" : notificationcount.unread_message_count}
                                                </span> : <></>
                                            }
                                        </p>
                                    </div>
                                </div>
                            </Link>

                            <div className="d-flex sidebar p-3 " role="button" onClick={() => navigate("/notifications", { state: { UserId: profile.user_id } })}>
                                <img src={p_nav_notifications_outline} width={"24px"} height={"24px"} alt='img' />
                                <div className="d-flex justify-content-between w-100">
                                    <div className="ff-poppins-regular fs-16 ms-3">
                                        Notification
                                    </div>
                                    <p className="">
                                        {notificationcount.unread_count > 0 ?
                                            <span className="notification_count">
                                                {notificationcount.unread_count >= 9 ? "9+" : notificationcount.unread_count}
                                            </span> : <></>
                                        }
                                    </p>
                                </div>
                            </div>

                            <Link to={`/aboutPingle`} className="text-decoration-none text-dark" >
                                <div className="d-flex p-3" role="button">
                                    <img src={p_nav_about_outline} width={"24px"} height={"24px"} alt='img' />
                                    <div className="ff-poppins-regular fs-16 ms-3">
                                        About Pingle
                                    </div>
                                </div>
                            </Link>

                            <Link to={`/settings`} className="text-decoration-none text-dark">
                                <div className="d-flex p-3" role="button">
                                    <img src={p_nav_setting_outline} width={"24px"} height={"24px"} alt='img' />
                                    <div className="ff-poppins-regular fs-16 ms-3">Settings</div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
                {showSidebar &&
                    <GuestUserSideBar isOpen={showSidebar} user={userData} onClose={() => setShowSidebar(false)} />
                }
            </div>

            <div className='vh-100'>
                <ul class="list-group">
                    <li class="list-group-item bg-transparent d-flex justify-content-between pt-3 pb-3">
                        <span className='ff-poppins-semiBold fs-16'>Language setting</span>
                        <span className='ff-poppins-regular fs-16'>English</span>
                    </li>
                </ul>

                <div role='button' onClick={() => { openModal() }} className='logoutBtn d-flex align-items-center justify-content-center primary-bg text-white ff-poppins-semiBold fs-16 m-2'>
                    {'Logout'}
                </div>

            </div>
            {/* onClick={() => logOut()} */}

            {/* logout Modal  */}

            {/* <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-sm m-0">
                    <div class="modal-content mx-3">
                        <div class="modal-body ps-5 pe-5 pt-4 pb-4">
                            <div className='text-center ff-poppins-semiBold fs-16 mb-3'>Delete account</div>
                            <div className='text-center ff-poppins-regular fs-12'>Are you sure you want to logout your account?</div>

                            <div className='d-flex justify-content-between mt-3'>
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
                                <button type="button" class="btn btn-danger" onClick={() => logOut()} data-bs-dismiss="modal">logout</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
            {/* Modal */}
            {modalOpen && (
                <div className="modal fade show successModal" style={{ display: 'block' }} tabIndex="-1" aria-labelledby="exampleModalLabel" aria-modal="true">
                    <div className="modal-dialog modal-dialog-centered modal-sm m-0" style={{ maxWidth: "360px" }}>
                        <div className="modal-content rounded-4">
                            <div className="modal-body p-4">
                                <div className='text-center ff-poppins-semiBold fs-18 '>Are you sure you want to logout?</div>
                                <div className="d-flex text-center justify-content-between mt-3">
                                    <div className="logout-modal-btn text-light primary-bg" onClick={() => logOut()}>Yes</div>
                                    <div className="logout-modal-btn primary-text primary-bg-light  ms-3" onClick={closeModal}>No</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Backdrop */}
            {modalOpen && <div className="modal-backdrop fade show"></div>}
        </>
    )
}

export default UserSettings
